import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as actions from './actions';

const initialState = {
  error: {},
  isLoading: false,
  isUpdating: false,
  conflict: false,
  list: [],
  detail: null,
  success: {},
  // Host
  hostList: [],
  hostDetail: null,
  hostIsLoading: false,
};

// Guest list
const setFetchComplaintsRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isLoading: { $set: true },
    success: { $set: {} },
  });

const setFetchComplaintsSuccess = (state, action) =>
  update(state, {
    isLoading: { $set: false },
    list: { $set: action.payload },
  });

const setFetchComplaintsFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isLoading: { $set: false },
  });

// Guest detail
const setFetchComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isLoading: { $set: true },
    success: { $set: {} },
  });

const setFetchComplaintSuccess = (state, action) =>
  update(state, {
    isLoading: { $set: false },
    detail: { $set: action.payload },
  });

const setFetchComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isLoading: { $set: false },
  });

// Create
const setCreateComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isUpdating: { $set: true },
    success: { $set: {} },
  });

const setCreateComplaintSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    detail: { $set: action.payload },
    success: { $set: { code: 'complaintCreated' } },
  });

const setCreateComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isUpdating: { $set: false },
  });

// Update
const setUpdateComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isUpdating: { $set: true },
    success: { $set: {} },
  });

const setUpdateComplaintSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    detail: { $set: action.payload },
    success: { $set: { code: 'complaintUpdated' } },
  });

const setUpdateComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isUpdating: { $set: false },
  });

// Withdraw
const setWithdrawComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isUpdating: { $set: true },
    success: { $set: {} },
  });

const setWithdrawComplaintSuccess = (state) =>
  update(state, {
    isUpdating: { $set: false },
    detail: { $set: null },
    success: { $set: { code: 'complaintWithdrawn' } },
  });

const setWithdrawComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isUpdating: { $set: false },
  });

// Guest respond (accept/reject counter-offer)
const setRespondComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isUpdating: { $set: true },
    success: { $set: {} },
  });

const setRespondComplaintSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    detail: { $set: action.payload },
    success: { $set: { code: 'complaintResponded' } },
  });

const setRespondComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isUpdating: { $set: false },
  });

// Image upload
const setUploadComplaintImageRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isUpdating: { $set: true },
  });

const setUploadComplaintImageSuccess = (state) =>
  update(state, {
    isUpdating: { $set: false },
  });

const setUploadComplaintImageFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isUpdating: { $set: false },
  });

// Host list
const setFetchHostComplaintsRequest = (state) =>
  update(state, {
    error: { $set: {} },
    hostIsLoading: { $set: true },
  });

const setFetchHostComplaintsSuccess = (state, action) =>
  update(state, {
    hostIsLoading: { $set: false },
    hostList: { $set: action.payload },
  });

const setFetchHostComplaintsFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    hostIsLoading: { $set: false },
  });

// Host detail
const setFetchHostComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    hostIsLoading: { $set: true },
    success: { $set: {} },
  });

const setFetchHostComplaintSuccess = (state, action) =>
  update(state, {
    hostIsLoading: { $set: false },
    hostDetail: { $set: action.payload },
  });

const setFetchHostComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    hostIsLoading: { $set: false },
  });

// Host respond
const setHostRespondComplaintRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isUpdating: { $set: true },
    success: { $set: {} },
  });

const setHostRespondComplaintSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    hostDetail: { $set: action.payload },
    success: { $set: { code: 'hostComplaintResponded' } },
  });

const setHostRespondComplaintFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isUpdating: { $set: false },
  });

// Image warning - clears success so only the error toast shows.
const setComplaintImageWarning = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    success: { $set: {} },
  });

// Conflict - stays true until complaintsReset (unmount).
// Intentionally not cleared on request actions since stale data
// should prevent further submissions until the user navigates away.
const setComplaintConflict = (state) =>
  update(state, {
    conflict: { $set: true },
  });

// Reset
const setComplaintsReset = () => ({ ...initialState });

export default handleActions(
  {
    [actions.FETCH_COMPLAINTS_REQUEST]: setFetchComplaintsRequest,
    [actions.FETCH_COMPLAINTS_SUCCESS]: setFetchComplaintsSuccess,
    [actions.FETCH_COMPLAINTS_FAILURE]: setFetchComplaintsFailure,

    [actions.FETCH_COMPLAINT_REQUEST]: setFetchComplaintRequest,
    [actions.FETCH_COMPLAINT_SUCCESS]: setFetchComplaintSuccess,
    [actions.FETCH_COMPLAINT_FAILURE]: setFetchComplaintFailure,

    [actions.CREATE_COMPLAINT_REQUEST]: setCreateComplaintRequest,
    [actions.CREATE_COMPLAINT_SUCCESS]: setCreateComplaintSuccess,
    [actions.CREATE_COMPLAINT_FAILURE]: setCreateComplaintFailure,

    [actions.UPDATE_COMPLAINT_REQUEST]: setUpdateComplaintRequest,
    [actions.UPDATE_COMPLAINT_SUCCESS]: setUpdateComplaintSuccess,
    [actions.UPDATE_COMPLAINT_FAILURE]: setUpdateComplaintFailure,

    [actions.WITHDRAW_COMPLAINT_REQUEST]: setWithdrawComplaintRequest,
    [actions.WITHDRAW_COMPLAINT_SUCCESS]: setWithdrawComplaintSuccess,
    [actions.WITHDRAW_COMPLAINT_FAILURE]: setWithdrawComplaintFailure,

    [actions.RESPOND_COMPLAINT_REQUEST]: setRespondComplaintRequest,
    [actions.RESPOND_COMPLAINT_SUCCESS]: setRespondComplaintSuccess,
    [actions.RESPOND_COMPLAINT_FAILURE]: setRespondComplaintFailure,

    [actions.UPLOAD_COMPLAINT_IMAGE_REQUEST]: setUploadComplaintImageRequest,
    [actions.UPLOAD_COMPLAINT_IMAGE_SUCCESS]: setUploadComplaintImageSuccess,
    [actions.UPLOAD_COMPLAINT_IMAGE_FAILURE]: setUploadComplaintImageFailure,

    [actions.FETCH_HOST_COMPLAINTS_REQUEST]: setFetchHostComplaintsRequest,
    [actions.FETCH_HOST_COMPLAINTS_SUCCESS]: setFetchHostComplaintsSuccess,
    [actions.FETCH_HOST_COMPLAINTS_FAILURE]: setFetchHostComplaintsFailure,

    [actions.FETCH_HOST_COMPLAINT_REQUEST]: setFetchHostComplaintRequest,
    [actions.FETCH_HOST_COMPLAINT_SUCCESS]: setFetchHostComplaintSuccess,
    [actions.FETCH_HOST_COMPLAINT_FAILURE]: setFetchHostComplaintFailure,

    [actions.HOST_RESPOND_COMPLAINT_REQUEST]: setHostRespondComplaintRequest,
    [actions.HOST_RESPOND_COMPLAINT_SUCCESS]: setHostRespondComplaintSuccess,
    [actions.HOST_RESPOND_COMPLAINT_FAILURE]: setHostRespondComplaintFailure,

    [actions.COMPLAINT_CONFLICT]: setComplaintConflict,
    [actions.COMPLAINT_IMAGE_WARNING]: setComplaintImageWarning,
    [actions.COMPLAINTS_RESET]: setComplaintsReset,
  },
  initialState,
);
